import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

import { parsePhoneInfo } from './formatPhoneNumber.utils';

function formatPhoneNumber(phone: string): string {
  if (!phone) return '';
  const parsed = parsePhoneInfo(phone);
  if (!parsed) return phone;
  return PhoneNumberUtil.getInstance().format(parsed, PhoneNumberFormat.INTERNATIONAL);
}

export { formatPhoneNumber };
